import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 全局数据源
import { ListStore } from '../../../store';
// 拉端
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import Observer from '@researchgate/react-intersection-observer';
// 新版Grounds
import { Grounds } from '@ifeng-fe/client_grounds';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import { publicPath } from '@src/constants';
import { WxLaunchApp } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchApp/dynamic';
const Relseries = ({ content }) => {
    const { item, index, id } = content;

    const {
        title,
        summary,
        thumbnails: { image },
        miniVideoPoster,
    } = item;
    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { currentVideo, dramaSeries, positive, gagsList, gags, related } = listStates;

    // 曝光相关推荐
    const handleObserverChangeRelseries = (entry, unobserve, index) => {
        const { isIntersecting } = entry;

        if (isIntersecting) {
            const { base62Id } = related[index];

            Grounds.expose({
                id: `phmovie_${base62Id}`,
                rnum: `${index}`,
                reftype: 'editor|||||||', // 不加encodeURL
                ch: `phmovie_${dramaSeries.base62Id}`,
                src: '',
                showtype: 'relseries',
                pagetype: 'phmovie',
            });
            // pageStatistics({
            //     behavior: 'pageinfo',
            //     // environment: 'client',
            //     id: `phmovie_${base62Id}`,
            //     rnum: `${index}`,
            //     reftype: 'editor|||||||', // 不加encodeURL
            //     ch: `phmovie_${dramaSeries.base62Id}`,
            //     src: '',
            //     showtype: 'relseries',
            //     pagetype: 'phmovie',
            // });

            unobserve();
        }
    };

    // 切换相关推荐
    const handleRecommondNum = (item, index, isJumpQQlink = false, isCallAppWx = true) => {
        // 替换id
        const url = `${publicPath}/details/${item.base62Id}`;

        if (!window.grounds) {

            if (isCallAppWx) {
                callApp({
                    docType: 'web',
                    pid: `${url}?needpage=1`,
                    kind: 'inter_da01',
                    noKindFrom: 1,
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1512057577113',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8927',
                    isJumpQQlink
                });
            }

            return;
        }

        const option = {
            link: {
                type: 'web',
                url: `${url}?needpage=1&id=phmovie_${item.base62Id}&type=phmovie&ref=phmovie_${
                    dramaSeries.base62Id
                }&reftype=${encodeURIComponent('editor|||||||')}&rnum=${index}&showtype=relseries&immersion=true`,
            },
        };

        Grounds.dispatch(option);
    };

    const SchemeLink = (item) => {
        const url = `${publicPath}/details/${item.base62Id}`;

        return getSchemeLink({
            docType: 'web',
            pid: `${url}?needpage=1`,
            kind: 'inter_da01',
            noKindFrom: 1,
        });
    };

    return (
        <Observer onChange={(entry, unobserve) => handleObserverChangeRelseries(entry, unobserve, index)}>
            <div className={`${styles.itemRecommondWrap}`} onClick={() => handleRecommondNum(item, index)}>
                {!window.grounds && currentVideo.base62Id !== item.base62Id ? (
                    <div className={styles.groundsTitle}>APP内播放</div>
                ) : null}
                {
                    !window.grounds &&
                    <WxLaunchApp
                        launchType="app"
                        launchAppClick={() => handleRecommondNum(item, index, false, false)}
                        schemeLink={SchemeLink(item)}
                        launchAppFail={() => handleRecommondNum(item, index, true, true)}
                    />
                }
                <img
                    className={styles.itemPoster}
                    src={formatImage(miniVideoPoster, 76, 106)}
                />
                <div className={styles.itemTitleWrap}>
                    <div className={styles.itemTitle}>{title}</div>
                    {/* <div className={styles.itemContent}>{summary}</div> */}
                </div>
            </div>
        </Observer>
    );
};

Relseries.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Relseries);
